import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {stretchDownAnimation} from '../../../_animations/stretchDown';

@Component({
  selector: 'app-share-item-selection-baner',
  templateUrl: './share-item-selection-baner.component.html',
  styleUrls: ['./share-item-selection-baner.component.scss', '../../../../multipleSelectionBaner.scss'],
  animations: [stretchDownAnimation]
})
export class ShareItemSelectionBanerComponent implements OnInit {
  @Input() currentlySelected: number;
  @Input() isAllSelected: boolean;
  @Input() canBeDownload: boolean;
  @Output() onAction: EventEmitter<string> = new EventEmitter();
  constructor() { }

  ngOnInit(): void {
  }

  clearSelection() {
    this.onAction.emit('clearSelection');
  }

  revokeSelection() {
    this.onAction.emit('revokeSelection');
  }

  selectAll() {
    this.onAction.emit('selectAll');
  }

}
